import KForm from 'app/components/Modules/Form/_KForm'
import KDateRange from 'app/components/Modules/Form/KDateRange'
import { convertStringToIso } from 'app/lib/apollo/normalizers/utilities'
import { useCurrentCustomer } from 'app/lib/hooks/useCurrent'
import { RecordTypeEnum } from 'app/queries'
import { omit } from 'lodash'
import * as React from 'react'

import { MemberProps } from '../convention'
import GuaranteedFormItem from '../LineItem/Form/GuaranteedFormItem'

const SubItemForm: React.FC<
  MemberProps<Partial<ISubItem>, Partial<React.ComponentProps<typeof KForm>>>
> = ({ member, children, props: { mutationOptions = {}, ...others } }) => {
  const { earliest_rental_start_date } = useCurrentCustomer()

  return (
    <KForm<Partial<ISubItem>>
      initialFetch={false}
      mutationOptions={{
        silentSuccess: true,
        payloadNormalizer: (values: ISubItem) => ({
          ...omit(values, 'dates'),
          startDate: convertStringToIso(values.startDate),
          returnDate: convertStringToIso(values.returnDate)
        }),
        ...mutationOptions
      }}
      recordId={member?.id}
      layout="vertical"
      initialValues={{
        ...member,
        start_date: member?.startDate || earliest_rental_start_date,
        return_date: member?.returnDate || earliest_rental_start_date
      }}
      recordType={RecordTypeEnum.subItem}
      {...others}>
      <KDateRange
        name={'dates'}
        minDate={earliest_rental_start_date}
        labelRenderer={(label: string) => <h5 className="text-black mb-0">{label}</h5>}
        startName="startDate"
        endName="returnDate"
      />
      <GuaranteedFormItem member={member} />
      {children}
    </KForm>
  )
}

export default SubItemForm
